import * as e from "react";
const t = (l) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    viewBox: "0 0 32 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...l
  },
  /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "LS_svg__a",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 32,
      height: 24
    },
    /* @__PURE__ */ e.createElement("path", { fill: "#fff", d: "M0 0h32v24H0z" })
  ),
  /* @__PURE__ */ e.createElement("g", { mask: "url(#LS_svg__a)", fillRule: "evenodd", clipRule: "evenodd" }, /* @__PURE__ */ e.createElement("path", { d: "M0 16h32v8H0v-8z", fill: "#55BA07" }), /* @__PURE__ */ e.createElement("path", { d: "M0 8h32v8H0V8z", fill: "#F7FCFF" }), /* @__PURE__ */ e.createElement("path", { d: "M0 0h32v8H0V0z", fill: "#3D58DB" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M15.25 8.24c-.523.14-.799.501-.799 1.14 0 .73.359 1.416.799 1.77V8.24zm1.25 2.89c.428-.358.772-1.031.772-1.748 0-.62-.272-.98-.772-1.13v2.878zm-.042-3.398c.818.181 1.41.739 1.41 1.644 0 .659-.313 1.46-.798 2.01l2.433 2.386.6-.197.897 1.36s-2.266 1.064-5.067 1.064C13.133 16 11 14.934 11 14.934l.763-1.162.617.202 2.257-2.547c-.507-.55-.836-1.375-.836-2.05 0-.938.635-1.503 1.498-1.663a.625.625 0 011.159.018zm-4.456 6.564l-.254.352h.494l-.24-.352zm.29.491l-.437.088.436.152v-.24zm.222-.508l.223.52.553-.15-.11-.21-.666-.16zm1.202 1.038l-.812-.16L12.81 15l.614-.134.292.45zm.048-.745l.252.455.556-.17-.155-.203-.653-.082zm.457.836l-.1-.188.615-.164.354.432-.87-.08zm1.148-.313l.792-.21-.098-.179h-1.028l.334.39zm.282.401l-.126-.194.761-.25.404.444h-1.039zm.964-.775l.244.298.659-.229-.083-.155-.82.086zm1.43.619l-.885.098-.13-.22.67-.22.346.342zm-.057-.764l.248.305.595-.305-.165-.092-.678.092zm.514.682l-.107-.165.566-.34.287.34-.746.165zm.563-.949l.359.343.35-.343-.111-.14-.599.14zm.57.46l.293-.29.21.29-.503.162v-.162z",
      fill: "#1D1D1D"
    }
  ))
), m = t;
export {
  m as default
};
